var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglePlayBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 28,
    viewBox: "0 0 76 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.9375,
    width: 75.1245,
    height: 28,
    rx: 4,
    fill: "#090909"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_5621_1183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43552 7.09001C8.27319 7.26249 8.17725 7.53017 8.17725 7.87681V20.2618C8.17725 20.609 8.27319 20.8761 8.43552 21.0486L8.4768 21.0889L15.3877 14.1511V14.0693V13.9875L8.4768 7.04913L8.43552 7.09001Z",
    fill: "url(#paint0_linear_5621_1183)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6909 16.4647L15.3877 14.1513V14.0695V13.9878L17.6915 11.675L17.7434 11.7047L20.4728 13.2615C21.2521 13.7061 21.2521 14.4335 20.4728 14.8787L17.7434 16.4355L17.6909 16.4647Z",
    fill: "url(#paint1_linear_5621_1183)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_5621_1183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7434 16.4351L15.3871 14.0696L8.43555 21.0489C8.69215 21.3222 9.11665 21.3558 9.5947 21.0836L17.7434 16.4351Z",
    fill: "url(#paint2_linear_5621_1183)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.7434 11.7042L9.5947 7.05618C9.11665 6.78346 8.69215 6.81762 8.43555 7.0909L15.3877 14.0702L17.7434 11.7042Z",
    fill: "url(#paint3_linear_5621_1183)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5849 14.7467C37.3458 14.7467 36.3358 15.6888 36.3358 16.9863C36.3358 18.2759 37.3458 19.2258 38.5849 19.2258C39.8246 19.2258 40.8345 18.2759 40.8345 16.9863C40.834 15.6888 39.824 14.7467 38.5849 14.7467ZM38.5849 18.3443C37.9058 18.3443 37.3205 17.7846 37.3205 16.9868C37.3205 16.1806 37.9063 15.6293 38.5849 15.6293C39.264 15.6293 39.8493 16.1806 39.8493 16.9868C39.8493 17.784 39.264 18.3443 38.5849 18.3443ZM33.6779 14.7467C32.4387 14.7467 31.4288 15.6888 31.4288 16.9863C31.4288 18.2759 32.4387 19.2258 33.6779 19.2258C34.9175 19.2258 35.9275 18.2759 35.9275 16.9863C35.9275 15.6888 34.9175 14.7467 33.6779 14.7467ZM33.6779 18.3443C32.9988 18.3443 32.4134 17.7846 32.4134 16.9868C32.4134 16.1806 32.9993 15.6293 33.6779 15.6293C34.357 15.6293 34.9423 16.1806 34.9423 16.9868C34.9428 17.784 34.357 18.3443 33.6779 18.3443ZM27.8415 15.4345V16.3844H30.1164C30.0484 16.9189 29.8703 17.3091 29.5985 17.5803C29.2676 17.911 28.7497 18.2759 27.8415 18.2759C26.4411 18.2759 25.3463 17.1474 25.3463 15.7478C25.3463 14.3481 26.4411 13.2197 27.8415 13.2197C28.597 13.2197 29.1486 13.5167 29.5558 13.8984L30.2265 13.2281C29.6575 12.6852 28.9025 12.2697 27.8415 12.2697C25.9232 12.2697 24.3105 13.8305 24.3105 15.7478C24.3105 17.665 25.9232 19.2258 27.8415 19.2258C28.8767 19.2258 29.658 18.8862 30.2686 18.2501C30.8966 17.6224 31.0921 16.7398 31.0921 16.0274C31.0921 15.8073 31.0752 15.6035 31.041 15.4339L27.8415 15.4345ZM51.7118 16.1722C51.5253 15.6719 50.9563 14.7467 49.7935 14.7467C48.6392 14.7467 47.6798 15.6546 47.6798 16.9863C47.6798 18.2416 48.6308 19.2258 49.9036 19.2258C50.9305 19.2258 51.5247 18.5981 51.7713 18.2332L51.0074 17.724C50.7529 18.0974 50.4047 18.3433 49.9036 18.3433C49.4031 18.3433 49.0465 18.1142 48.8173 17.6645L51.8135 16.426L51.7118 16.1722ZM48.6561 16.9189C48.6308 16.0532 49.3267 15.6124 49.8278 15.6124C50.2182 15.6124 50.549 15.8078 50.6597 16.0874L48.6561 16.9189ZM46.2205 19.0905H47.2046V12.5077H46.2205V19.0905ZM44.6073 15.2475H44.5735C44.3528 14.9842 43.9282 14.7467 43.3939 14.7467C42.2733 14.7467 41.2465 15.7309 41.2465 16.9952C41.2465 18.2506 42.2733 19.2263 43.3939 19.2263C43.9287 19.2263 44.3528 18.9889 44.5735 18.7177H44.6073V19.0399C44.6073 19.8967 44.1489 20.3548 43.4108 20.3548C42.8081 20.3548 42.4346 19.9225 42.2818 19.5576L41.4246 19.9141C41.6706 20.5075 42.3239 21.2373 43.4108 21.2373C44.5651 21.2373 45.5414 20.5586 45.5414 18.9041V14.8831H44.6078L44.6073 15.2475ZM43.4788 18.3443C42.7997 18.3443 42.2312 17.7756 42.2312 16.9952C42.2312 16.2059 42.7997 15.6293 43.4788 15.6293C44.1489 15.6293 44.6752 16.2059 44.6752 16.9952C44.6752 17.7756 44.1489 18.3443 43.4788 18.3443ZM56.3238 12.5077H53.9682V19.0905H54.9508V16.5966H56.3232C57.4128 16.5966 58.4844 15.8083 58.4844 14.5524C58.4844 13.2965 57.4133 12.5077 56.3238 12.5077ZM56.3491 15.6804H54.9508V13.424H56.3491C57.084 13.424 57.5013 14.0322 57.5013 14.5524C57.5013 15.0622 57.084 15.6804 56.3491 15.6804ZM62.4246 14.7352C61.7129 14.7352 60.9758 15.0485 60.6708 15.743L61.5432 16.1069C61.7297 15.743 62.0774 15.624 62.4415 15.624C62.9499 15.624 63.4667 15.9289 63.4752 16.4708V16.5387C63.2971 16.4371 62.9157 16.2849 62.4499 16.2849C61.5095 16.2849 60.5517 16.8014 60.5517 17.7667C60.5517 18.6476 61.323 19.2148 62.187 19.2148C62.8477 19.2148 63.2123 18.9183 63.4409 18.5708H63.4746V19.0789H64.424V16.555C64.4245 15.3871 63.551 14.7352 62.4246 14.7352ZM62.3056 18.3427C61.9842 18.3427 61.5348 18.1816 61.5348 17.7835C61.5348 17.2754 62.0943 17.0805 62.5774 17.0805C63.0089 17.0805 63.2128 17.1737 63.4752 17.3006C63.3988 17.911 62.8735 18.3427 62.3056 18.3427ZM67.8812 14.8789L66.7543 17.733H66.7205L65.5509 14.8789H64.492L66.2459 18.8677L65.2459 21.0867H66.2711L68.9744 14.8789H67.8812ZM59.027 19.0905H60.0096V12.5077H59.027V19.0905Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7184 8.61451C27.7184 9.04779 27.5878 9.39265 27.3262 9.65014C27.0293 9.95623 26.6419 10.1093 26.1661 10.1093C25.7103 10.1093 25.3223 9.95416 25.0039 9.64393C24.6849 9.33319 24.5254 8.94852 24.5254 8.48939C24.5254 8.02974 24.6849 7.64507 25.0039 7.33484C25.3223 7.0241 25.7103 6.86899 26.1661 6.86899C26.3924 6.86899 26.6088 6.91242 26.8141 6.99877C27.0199 7.08563 27.1846 7.20093 27.3078 7.34518L27.0304 7.61818C26.8214 7.37259 26.5335 7.25005 26.1656 7.25005C25.8329 7.25005 25.5455 7.36483 25.3028 7.5944C25.0602 7.82396 24.9391 8.12229 24.9391 8.48887C24.9391 8.85545 25.0602 9.15378 25.3028 9.38335C25.5455 9.61291 25.8329 9.72769 26.1656 9.72769C26.5182 9.72769 26.8125 9.6124 27.0478 9.38128C27.2004 9.23082 27.2889 9.02142 27.3125 8.75308H26.1656V8.38029H27.6957C27.7115 8.46147 27.7184 8.53954 27.7184 8.61451Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.145 7.31884H28.707V8.30225H30.0039V8.67503H28.707V9.65844H30.145V10.04H28.3011V6.93779H30.145V7.31884Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8562 10.04H31.4504V7.31884H30.5681V6.93779H32.7384V7.31884H31.8562V10.04Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3085 10.04V6.93779H34.7144V10.04H34.3085Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5141 10.04H36.1083V7.31884H35.2261V6.93779H37.3963V7.31884H36.5141V10.04Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5046 9.63931C41.194 9.95263 40.8082 10.1093 40.3465 10.1093C39.8849 10.1093 39.4991 9.95263 39.189 9.63931C38.8785 9.32598 38.7237 8.94234 38.7237 8.4889C38.7237 8.03545 38.8785 7.65181 39.189 7.33849C39.4991 7.02516 39.8849 6.86798 40.3465 6.86798C40.8055 6.86798 41.1908 7.02568 41.5025 7.34055C41.8141 7.65543 41.9699 8.03804 41.9699 8.4889C41.9699 8.94234 41.8146 9.32598 41.5046 9.63931ZM39.4885 9.37924C39.7223 9.6119 40.0081 9.72772 40.3465 9.72772C40.685 9.72772 40.9713 9.61139 41.2045 9.37924C41.4382 9.14657 41.5556 8.84979 41.5556 8.4889C41.5556 8.128 41.4382 7.83122 41.2045 7.59856C40.9713 7.36589 40.685 7.25007 40.3465 7.25007C40.0081 7.25007 39.7223 7.36641 39.4885 7.59856C39.2554 7.83122 39.138 8.128 39.138 8.4889C39.138 8.84979 39.2554 9.14657 39.4885 9.37924Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5394 10.04V6.93779H43.0332L44.5681 9.3508H44.5854L44.5681 8.75311V6.93779H44.9739V10.04H44.5502L42.9442 7.50963H42.9268L42.9442 8.10733V10.04H42.5394Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7184 8.61451C27.7184 9.04779 27.5878 9.39265 27.3262 9.65014C27.0293 9.95623 26.6419 10.1093 26.1661 10.1093C25.7103 10.1093 25.3223 9.95416 25.0039 9.64393C24.6849 9.33319 24.5254 8.94852 24.5254 8.48939C24.5254 8.02974 24.6849 7.64507 25.0039 7.33484C25.3223 7.0241 25.7103 6.86899 26.1661 6.86899C26.3924 6.86899 26.6088 6.91242 26.8141 6.99877C27.0199 7.08563 27.1846 7.20093 27.3078 7.34518L27.0304 7.61818C26.8214 7.37259 26.5335 7.25005 26.1656 7.25005C25.8329 7.25005 25.5455 7.36483 25.3028 7.5944C25.0602 7.82396 24.9391 8.12229 24.9391 8.48887C24.9391 8.85545 25.0602 9.15378 25.3028 9.38335C25.5455 9.61291 25.8329 9.72769 26.1656 9.72769C26.5182 9.72769 26.8125 9.6124 27.0478 9.38128C27.2004 9.23082 27.2889 9.02142 27.3125 8.75308H26.1656V8.38029H27.6957C27.7115 8.46147 27.7184 8.53954 27.7184 8.61451Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.145 7.31884H28.707V8.30225H30.0039V8.67503H28.707V9.65844H30.145V10.04H28.3011V6.93779H30.145V7.31884Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8562 10.04H31.4504V7.31884H30.5681V6.93779H32.7384V7.31884H31.8562V10.04Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3085 10.04V6.93779H34.7144V10.04H34.3085Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5141 10.04H36.1083V7.31884H35.2261V6.93779H37.3963V7.31884H36.5141V10.04Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5046 9.63931C41.194 9.95263 40.8082 10.1093 40.3465 10.1093C39.8849 10.1093 39.4991 9.95263 39.189 9.63931C38.8785 9.32598 38.7237 8.94234 38.7237 8.4889C38.7237 8.03545 38.8785 7.65181 39.189 7.33849C39.4991 7.02516 39.8849 6.86798 40.3465 6.86798C40.8055 6.86798 41.1908 7.02568 41.5025 7.34055C41.8141 7.65543 41.9699 8.03804 41.9699 8.4889C41.9699 8.94234 41.8146 9.32598 41.5046 9.63931ZM39.4885 9.37924C39.7223 9.6119 40.0081 9.72772 40.3465 9.72772C40.685 9.72772 40.9713 9.61139 41.2045 9.37924C41.4382 9.14657 41.5556 8.84979 41.5556 8.4889C41.5556 8.128 41.4382 7.83122 41.2045 7.59856C40.9713 7.36589 40.685 7.25007 40.3465 7.25007C40.0081 7.25007 39.7223 7.36641 39.4885 7.59856C39.2554 7.83122 39.138 8.128 39.138 8.4889C39.138 8.84979 39.2554 9.14657 39.4885 9.37924Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5394 10.04V6.93779H43.0332L44.5681 9.3508H44.5854L44.5681 8.75311V6.93779H44.9739V10.04H44.5502L42.9442 7.50963H42.9268L42.9442 8.10733V10.04H42.5394Z",
    stroke: "white",
    strokeWidth: 0.204511,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_5621_1183",
    x: 8.17725,
    y: 6.86798,
    width: 12.8799,
    height: 14.4036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5621_1183"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_5621_1183",
    result: "effect2_innerShadow_5621_1183"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_5621_1183",
    x: 8.43555,
    y: 14.0696,
    width: 9.30762,
    height: 7.20197,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.795
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5621_1183"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5621_1183",
    x1: 14.7751,
    y1: 7.74577,
    x2: 5.37721,
    y2: 17.1071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5621_1183",
    x1: 21.4872,
    y1: 14.0695,
    x2: 7.99018,
    y2: 14.0695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5621_1183",
    x1: 16.4638,
    y1: 15.3542,
    x2: 3.71913,
    y2: 28.0493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5621_1183",
    x1: 6.68476,
    y1: 2.96807,
    x2: 12.3756,
    y2: 8.63679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBlack);
export default __webpack_public_path__ + "static/media/GooglePlayBlack.a652cfdde2787e9c097e0e0e4f817b2c.svg";
export { ForwardRef as ReactComponent };